import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { TeacherSubmissionListPage } from '@/features/teacherSubmissions/pages/TeacherSubmissionListPage';
import { teacherSubmissionSearchSchema } from '@/features/teacherSubmissions/types/teacherSubmission.types';

export const Route = createFileRoute('/_auth/settings/teacher-submissions/')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.TEACHER_VIEW),
  validateSearch: teacherSubmissionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Teacher Submissions">
      <Suspense fallback={<PageLoader />}>
        <TeacherSubmissionListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
